import ABKAccordion from "../ABKAccordionAlt";
import {AccordionData} from "../../interfaces/AccordionData";
import useGetSupportCenterQuery from "./queries/useGetSupportCenterQuery";


const SupportAccordion = () => {

    const {data: supportCenter} = useGetSupportCenterQuery();

    const kundenZentrumData: AccordionData[] = [
        {label: "Name", size: 6, value: supportCenter?.name},
        {label: "E-Mail", size: 6, value: supportCenter?.email},
        {label: "Telefon", size: 6, value: supportCenter?.telefon},
        {label: "Webseite", size: 6, value: supportCenter?.webseite},
    ]

    return <ABKAccordion isInput={false} accordionTitle={"ABK-Kundenzentrum"} data={kundenZentrumData} />
}

export default SupportAccordion;